import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedStaffNoteUpdatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface StaffNoteUpdatedEventProps {
  event: DiscriminatedStaffNoteUpdatedEvent;
}

export const StaffNoteUpdatedEvent: React.FC<StaffNoteUpdatedEventProps> = ({
  event,
}) => {
  const content = event.payload.content || event.payload.staff_note?.content;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center">
          <PencilIcon className="h-4 w-4 text-gray-400" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {content && (
        <ActivityDescription>
          <div className="text-sm text-gray-600 italic">
            &ldquo;{content}&rdquo;
          </div>
        </ActivityDescription>
      )}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Note Updated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
